import { render, staticRenderFns } from "./joinIn.vue?vue&type=template&id=45b138d8&scoped=true&"
import script from "./joinIn.vue?vue&type=script&lang=js&"
export * from "./joinIn.vue?vue&type=script&lang=js&"
import style0 from "./joinIn.vue?vue&type=style&index=0&id=45b138d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b138d8",
  null
  
)

export default component.exports